import React from 'react';

function About() {
  return (
    <section id="about" className="about-mini reveal">
      <div className="about-mini__inner">
        {/* Profilfoto – Platzhalter bis echtes Foto vorliegt */}
        <div className="about-mini__photo">
          <div className="about-mini__photo-placeholder">
            <span className="about-mini__photo-initials">CS</span>
          </div>
        </div>

        <div className="about-mini__content">
          <h2>Der Kopf hinter TechSoul</h2>
          <p>
            <strong>Christian Sachau</strong> ist Technischer Betriebswirt und Bereichsleiter Operations.
            Seine Erfahrung aus über 15 Jahren Führung, Service Management und Prozessoptimierung
            bildet die Grundlage für die Entwicklung von TechSoul.
          </p>
          <p className="about-mini__accent">
            Pragmatisches Know-how statt Theorie. Jedes Werkzeug entstand aus echten Herausforderungen.
          </p>
        </div>
      </div>
    </section>
  );
}

export default About;
